<template>
  <div class="rootDiv">
    <Navbar v-model="selected">
      <TabItem id="1">车牌查城市</TabItem>
      <TabItem id="2">城市查车牌</TabItem>
    </Navbar>
    <TabContainer v-model="selected">
      <TabContainerItem id="1" class="containerclass">
        <IndexList>
          <IndexSection v-for="item in licensePlateList" :key="item.index" :index="item.index">
            <div v-for="temp in item.list" :key="temp.cP+temp.dQ">
              <a class="mint-cell">
                <div class="mint-cell-wrapper">
                  <div class="mint-cell-title">
                    <span class="mint-cell-text" style="color: green">{{ temp.cP }}</span>
                    <span class="mint-cell-text"> ==> </span>
                    <span class="mint-cell-text">{{ temp.sF }}-{{ temp.dQ }}</span>
                  </div>
                </div>
              </a>
            </div>
          </IndexSection>
        </IndexList>
      </TabContainerItem>
      <TabContainerItem id="2" class="containerclass">
        <IndexList>
          <IndexSection v-for="item in cityList" :key="item.index" :index="item.index">
            <div v-for="temp in item.list" :key="temp.cP+temp.dQ">
              <a class="mint-cell">
                <div class="mint-cell-wrapper">
                  <div class="mint-cell-title">
                    <span class="mint-cell-text" style="color: green">{{ temp.sF }}-{{ temp.dQ }}</span>
                    <span class="mint-cell-text">=></span>
                    <span class="mint-cell-text">{{ temp.cP }}</span>
                  </div>
                </div>
              </a>
            </div>
          </IndexSection>
        </IndexList>
      </TabContainerItem>
    </TabContainer>
  </div>
</template>

<script>
import {IndexList, IndexSection, Navbar, TabItem, TabContainer, TabContainerItem} from 'mint-ui';

export default {
  name: "LicensePlate",
  components: {
    IndexList, IndexSection, Navbar, TabItem, TabContainer, TabContainerItem
  },
  mounted() {
    this.getData()
  },
  data() {
    return {
      selected: '1',
      licensePlateList: [],
      cityList: [],
      licensePlate: {
        index: null,
        sF: null,
        dQ: null,
        cP: null,
        qT: null,
      },
      token: localStorage.getItem('token'),
      getLicensePlateWithCityUrl: '/api/otherapi/getLicensePlateWithCity',
      getCityWithLicensePlateUrl: '/api/otherapi/getCityWithLicensePlate',
    }
  },
  methods: {
    getData() {
      let that = this
      that.$ajax({
        method: 'get',
        url: that.getLicensePlateWithCityUrl,
        headers: {token: that.token, needToken: 'false'}
      }).then((response) => {
        that.licensePlateList = response.data['responseData']
      }).catch(response => {
        that.$messagebox.alert(response.request.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商", '服务器异常')
      })
      that.$ajax({
        method: 'get',
        url: that.getCityWithLicensePlateUrl,
        headers: {token: that.token, needToken: 'false'}
      }).then((response) => {
        that.cityList = response.data['responseData']
      }).catch(response => {
        that.$messagebox.alert(response.request.status === 404 ? "服务器连接失败" : "未知错误，请联系服务商", '服务器异常')
      })
    },
  },
}
</script>

<style lang="less" scoped>
.rootDiv {
  .mint-navbar .mint-tab-item.is-selected {
    margin-bottom: 0;
  }
}

.containerclass {

}
</style>
